"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _tinymce = _interopRequireDefault(require("tinymce"));

var _plugins = require("../constants/plugins");

var _transformer = require("../utils/transformer");

var _utils = require("../utils");

var blackListAttributes = ['data-popover-id'];

var getTransformOut = function getTransformOut(dom) {
  blackListAttributes.forEach(function (attribute) {
    var nodes = (0, _toConsumableArray2.default)(dom.body.querySelectorAll("[" + attribute + "]"));
    nodes.forEach(function (node) {
      node.removeAttribute(attribute);
    });
  });
};

function hsSanitize(editor) {
  if (!(0, _utils.hasPlugin)(editor, _plugins.HS_TRANSFORMER)) {
    throw new Error("[tinymce-plugins] " + _plugins.HS_SANITIZE + " requires the " + _plugins.HS_TRANSFORMER + " plugin");
  }

  (0, _transformer.addPostProcessTransform)(editor, getTransformOut);
}

_tinymce.default.PluginManager.add(_plugins.HS_SANITIZE, hsSanitize);